import * as React from 'react';

type Props = {
  spacing: number;
  vertical?: boolean;
  horizontal?: boolean;
};

function getSpacing(index: number) {
  switch (index) {
    case 0:
      return 0;
    case 1:
      return 10;
    case 2:
      return 20;
    case 3:
      return 30;
    case 4:
      return 40;
    case 5:
      return 90;
    case 6:
      return 140;
    case 7:
      return 326;
  }
  return 0;
}

function Spacer({ spacing, vertical, horizontal }: Props) {
  const addedStyle: any = {};

  if (vertical && horizontal) {
    throw new Error('Cannot have both vertical and horizontal spacing');
  }

  if (vertical) {
    addedStyle.height = getSpacing(spacing);
  }
  if (horizontal) {
    addedStyle.width = getSpacing(spacing);
  }
  return <div style={addedStyle}></div>;
}

export default Spacer;
